import { useMutation, useQueryClient } from 'react-query';

import { startVisitTimerFetch as startTimer } from 'api/visitReports/startVisitTimer';

// Створення POST # 3 " Створюю хук для контроля стану ( Наприклад можна виконувати якісь дії на isSuccess ) " | Start Block |

const useStartVisitTimer = () => {
  const queryClient = useQueryClient();

  const {
    isSuccess,
    mutate: startVisitTimer,
    isLoading,
  } = useMutation(startTimer, {
    onSuccess: () => {
      queryClient.invalidateQueries('visitDocs');
    },
  });

  return {
    isSuccess,
    startVisitTimer,
    isLoading,
  };
};

// Створення POST # 3 " Створюю хук для контроля стану ( Наприклад можна виконувати якісь дії на isSuccess ) " | End Block |

export default useStartVisitTimer;
